import { useEffect, useRef, useState } from "react";
import {
  AiAvatarIcon,
  Button,
  ChatDialog,
  ChatUi,
  HistoryIcon,
  InputWithLabel,
  SendIcon,
  X,
} from "@ptsd/uikit";
import { ScrollView, Text, View, XStack, YStack } from "tamagui";

import { extractInitials } from "~/utils/extractInitials";
import type { ChatContentProps } from "~/component/feature/chat-bot/chat-holder";
import { useMe } from "~/hooks";

export const ChatContentMobile = ({
  text,
  onChangeText,
  onChangeChat,
  isLoading,
  isDisabled,
  onSubmit,
  messages,
  followups,
  chatId,
  chatHistory,
  isChatLoading,
  onCreateFirstChat,
}: ChatContentProps) => {
  const [layout, setLayout] = useState<{
    width: number;
    height: number;
  }>();

  const [isHistoryOpened, setIsHistoryOpened] = useState(true);

  const scrollRef = useRef<ScrollView | null>(null);
  const person = useMe();
  const userName = extractInitials(person.name);

  useEffect(() => {
    setIsHistoryOpened(() => {
      return false;
    });
  }, [chatId, setIsHistoryOpened]);

  //TODO:: find better solution for scrolling to bottom
  useEffect(() => {
    try {
      scrollRef.current?.scrollToEnd({ animated: true });
    } catch (e) {
      console.log("scroll to bottom error", e);
    }
  }, [messages, isLoading, followups]);

  return (
    <View
      flex={1}
      width={"100%"}
      paddingHorizontal={"$1.2"}
      onLayout={(e) =>
        setLayout({
          height: e.nativeEvent.layout.height,
          width: e.nativeEvent.layout.width,
        })
      }
    >
      <ChatUi.Container
        height={layout?.height}
        width={layout?.width}
        style={{
          flex: 1,
          backgroundColor: "white",
          borderWidth: 1,
          borderColor: "#CDD3DC",
          borderRadius: 14,
          overflow: "hidden",
        }}
      >
        <>
          <View
            style={{
              flex: 10,
              justifyContent: "space-between",
            }}
          >
            <ChatUi.Header
              flex={1}
              flexDirection="row"
              alignItems="center"
              justifyContent="space-between"
              paddingHorizontal={"$3"}
              maxHeight="$10"
            >
              <XStack gap={"$1"}>
                <Button
                  {...(isHistoryOpened && {
                    borderColor: "$lightgreen-500",
                    borderWidth: "$0.2",
                    outlineWidth: 0,
                  })}
                  focusStyle={
                    isHistoryOpened && {
                      borderColor: "$lightgreen-500",
                      borderWidth: "$0.1",
                      outlineWidth: 0,
                    }
                  }
                  variant={isHistoryOpened ? "primary" : "outlined"}
                  size="md"
                  rounded="lg"
                  mode="icon"
                  onPress={() => {
                    setIsHistoryOpened((v) => !v);
                  }}
                >
                  <HistoryIcon />
                </Button>
                <YStack>
                  <XStack alignItems="center" gap={"$1"}>
                    <Text
                      fontFamily={"$body"}
                      fontWeight={"$5"}
                      fontSize={"$3"}
                      lineHeight={"$3"}
                      color={"white"}
                    >
                      AI-помічник
                    </Text>
                    <AiAvatarIcon />
                  </XStack>
                  <Text
                    fontFamily={"$body"}
                    fontWeight={"$4"}
                    fontSize={"$3"}
                    lineHeight={"$3"}
                    color={"$gray-secondary-400"}
                    numberOfLines={1}
                    ellipsizeMode="tail"
                    width={"calc(100vw - 150px)"}
                  >
                    {chatHistory?.find((chat) => chat.id === chatId)?.name ??
                      "Без назви"}
                  </Text>
                </YStack>
              </XStack>
              <XStack>
                <ChatDialog.Close size="sm" mode="icon" padding={0}>
                  <X color="#CDD3DC" />
                </ChatDialog.Close>
              </XStack>
            </ChatUi.Header>

            {isHistoryOpened && (
              <View
                overflow="hidden"
                style={{
                  flex: 8,
                  flexDirection: "row",
                  height: "100%",
                  width: "100%",
                  position: "relative",
                }}
              >
                <View
                  style={{
                    position: "absolute",
                    justifyContent: "space-between",
                    backgroundColor: "white",
                    zIndex: 100,
                    height: "100%",
                    width: "100%",
                  }}
                >
                  <ScrollView
                    height={"100%"}
                    maxWidth={"100%"}
                    paddingVertical={"$3"}
                    paddingHorizontal={"$2"}
                    contentContainerStyle={{
                      gap: "$2",
                    }}
                  >
                    <View alignItems="center" gap={"$3"}>
                      <YStack alignItems="center" width={"100%"} gap={"$1"}>
                        <Text
                          fontFamily={"$body"}
                          fontWeight={"$6"}
                          fontSize={"$3"}
                          lineHeight={"$3"}
                          color={"$gray-primary-900"}
                        >
                          Історія чатів
                        </Text>
                        <Button variant="primary" size="md" rounded="lg">
                          Новий чат
                        </Button>
                      </YStack>
                    </View>
                    {chatHistory?.map((item) => (
                      <ChatUi.HistoryItem
                        onPress={() => onChangeChat(item.id)}
                        isActive={item.id === chatId}
                        key={item.id}
                        id={item.id}
                        summaryId={item.summary_id}
                        name={item.name}
                        createdAt={item.created_at}
                        tags={item.tags}
                        chatSummary={item.chat_summary}
                      />
                    ))}
                  </ScrollView>
                </View>
              </View>
            )}
            {!isHistoryOpened && (
              <YStack
                overflow="hidden"
                style={{
                  flex: 8,
                  flexDirection: "column",
                  height: "100%",
                  width: "100%",
                  position: "relative",
                }}
              >
                <View zIndex={99} flex={1}>
                  <View
                    style={{
                      flex: 1,
                      maxWidth: 758,
                      width: "100%",
                      alignSelf: "center",
                    }}
                  >
                    <ScrollView
                      ref={scrollRef}
                      contentContainerStyle={{
                        width: "100%",
                        alignSelf: "center",
                        gap: 20,
                        justifyContent: "flex-end",
                        paddingTop: "$1",
                        paddingHorizontal: "$3",
                        paddingBottom: 20,
                      }}
                    >
                      {isChatLoading && <ChatUi.Loader />}
                      {messages?.map(({ mine, at, isIntro, ...rest }, i) => (
                        <ChatUi.Message
                          key={i}
                          userInitial={userName}
                          mine={mine}
                          atText={
                            at?.toLocaleTimeString([], {
                              hour: "2-digit",
                              minute: "2-digit",
                            }) ?? ""
                          }
                          {...rest}
                        >
                          {isIntro && (
                            <View display={"inline-flex"}>
                              <Button
                                disabled={isLoading}
                                rounded="md"
                                size="md"
                                variant="primary"
                                onPress={onCreateFirstChat}
                              >
                                Що показали результати?
                              </Button>
                            </View>
                          )}
                        </ChatUi.Message>
                      ))}
                      {!isLoading && followups && followups.length > 0 ? (
                        <ChatUi.QuickAnswers
                          shortAnswers={followups}
                          onPress={(question) => onSubmit(question)}
                        />
                      ) : null}
                      {isLoading && (
                        <ChatUi.TypingDots
                          marginLeft={"$6"}
                          paddingBottom={"$3"}
                        />
                      )}
                    </ScrollView>
                  </View>
                  <XStack
                    flex={0}
                    paddingHorizontal={"$3"}
                    alignItems="center"
                    justifyContent="center"
                    flexDirection="row"
                    gap={"$1"}
                    zIndex={100}
                    backgroundColor="white"
                    height="$8.5"
                  >
                    <InputWithLabel
                      variant="stacked"
                      borderColor={"$gray-100"}
                      height={"$5"}
                      maxWidth={682}
                      placeholder="Напишіть повідомлення..."
                      value={text}
                      onChangeText={onChangeText}
                    />

                    <Button
                      mode="icon"
                      variant="gray"
                      rounded="lg"
                      height={"$5"}
                      width={"$5"}
                      backgroundColor={"$gray-secondary-400"}
                      onPress={() => onSubmit(text)}
                      disabled={isDisabled || isLoading}
                      borderWidth={0}
                    >
                      <SendIcon height={20} width={20} />
                    </Button>
                  </XStack>
                </View>
              </YStack>
            )}
          </View>
        </>
      </ChatUi.Container>
    </View>
  );
};
